import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { useUser } from '@common/application/store/user';
import { ROUTE_MAP } from '@common/constants/route-map';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
export const User = () => {
    const { t } = useTranslation();
    const { user } = useUser();
    return (user === null || user === void 0 ? void 0 : user.id) ? (_jsx(Link, Object.assign({ href: ROUTE_MAP.ACCOUNT }, { children: _jsxs("span", Object.assign({ className: "px-4 border-r cursor-pointer" }, { children: [user === null || user === void 0 ? void 0 : user.name, "\u00A0", user === null || user === void 0 ? void 0 : user.surname] })) }))) : (_jsx(Link, Object.assign({ href: ROUTE_MAP.LOGIN }, { children: _jsx("span", Object.assign({ className: "px-4 border-r cursor-pointer" }, { children: t('common:languageHeader.login') })) })));
};
